import { Trans } from 'react-i18next';

// export const GemTypeMap = {
//     gam1: '<span className="trigram">☵</span>1',
//     gan2: '<span className="trigram">☳</span>2',
//     jin3: '<span className="trigram">☶</span>3',
//     son4: '<span className="trigram">☱</span>4',
//     ri5: '<span className="trigram">☲</span>5',
//     gon6: '<span className="trigram">☷</span>6',
//     tae7: '<span className="trigram">☴</span>7',
//     geon8: '<span className="trigram">☰</span>8',
// } as const;

export const GemTypeMap = {
    gam1: '☵1',
    gan2: '☳2',
    jin3: '☶3',
    son4: '☱4',
    ri5: '☲5',
    gon6: '☷6',
    tae7: '☴7',
    geon8: '☰8',
} as const;

export type GemItemType = keyof typeof GemTypeMap;

export type GemTypeString = (typeof GemTypeMap)[GemItemType];

export function getGemTypeString(type: GemItemType) {
    if (GemTypeMap[type]) {
        return <Trans components={{ span: <span /> }}>{GemTypeMap[type]}</Trans>;
    } else {
        return <></>;
    }
}

export function isGemItemType(value: string): value is GemItemType {
    return value in GemTypeMap;
}
